import apiClient from "./apiClient";

const BASE = "/api/Appointment";

const toDateTime = (d) => (d ? `${d}T00:00:00` : null);

const toTimeSpan = (t) => {
  if (!t) return null;
  const clean = t.split(".")[0]; // strip microseconds
  return clean.length === 5 ? `${clean}:00` : clean; // ensure "HH:mm:ss"
};

// If toTime is missing, default to fromTime + 30 minutes
const toTimeOrDefault = (toTime, fromTime) => {
  if (toTime) return toTimeSpan(toTime);
  if (!fromTime) return null;
  const [h, m] = fromTime.split(":").map(Number);
  const total = (h || 0) * 60 + (m || 0) + 30;
  const hh = String(Math.floor(total / 60) % 24).padStart(2, "0");
  const mm = String(total % 60).padStart(2, "0");
  return `${hh}:${mm}:00`;
};

// Get appointments by date (YYYY-MM-DD)
export const getAppointments = (params) => {
  const date = params?.date || params?.from || new Date().toISOString().split("T")[0];
  return apiClient.get(`${BASE}/date/${date}`);
};

// Get appointments for a specific doctor on a specific date
export const getAppointmentsByDoctor = (doctorId, date) =>
  apiClient.get(`${BASE}/doctor/${doctorId}/date/${date}`);

// For the calendar: fetch by date (single day at a time)
export const getCalendarAppointments = (from) => {
  // toISOString() would convert "now" to UTC, shifting the date backward a day in
  // positive-UTC-offset timezones (e.g. IST) — use local date parts instead.
  const today = () => {
    const d = new Date();
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
  };
  const date = from || today();
  return apiClient.get(`${BASE}/date/${date}`);
};

export const getAppointment = (id) => apiClient.get(`${BASE}/${id}`);

// Book new appointment — always send a valid toTime (default: fromTime + 30 min)
export const createAppointment = (data) =>
  apiClient.post(`${BASE}/book`, {
    appointmentDate: toDateTime(data.appointmentDate),
    fromTime: toTimeSpan(data.fromTime),
    toTime: toTimeOrDefault(data.toTime, data.fromTime),
    patientID: Number(data.patientId || data.patientID),
    doctorID: Number(data.doctorId || data.doctorID),
    procedureID: Number(data.procedureId || data.procedureID) || null,
    status: data.status || "Booked",
    remarks: data.remarks || "",
  });

// Only status can be updated via the API
export const updateAppointment = (id, data) =>
  apiClient.post(`${BASE}/update-status`, {
    appointmentID: id,
    status: data.status,
  });

export const deleteAppointment = () => Promise.reject(new Error("Delete not supported by API"));

export const getNextToken = () => Promise.resolve({ data: { token: "" } });
